import {z} from 'zod';

import {Locale} from '@dms/api/base';
import i18n from '@dms/i18n';

const MAX_NAME_LENGTH = 255;

const LOCALES = [
  'cs-CZ',
  'de-DE',
  'de-BE',
  'en-GB',
  'en-US',
  'es-ES',
  'fr-FR',
  'fr-BE',
  'it-IT',
  'pl-PL',
  'sk-SK',
  'nl-BE',
  'nl-NL',
] as const satisfies readonly Locale[];

export const codeFormSchema = z.object({
  name: z
    .string()
    .trim()
    .nonempty({message: i18n.t('errors.field_is_required')})
    .max(MAX_NAME_LENGTH),
  localizedNames: z
    .array(
      z.object({
        locale: z.enum(LOCALES),
        name: z.string().trim().max(MAX_NAME_LENGTH),
      })
    )
    .optional(),
});

export type CodeFormValue = z.infer<typeof codeFormSchema>;
